import React, { useMemo } from 'react';
import {
  AppButton,
  Box,
  FiservCardInterface,
  FiservCardStatusEnum,
  LockIcon,
  Preloader,
  UnlockIcon,
} from '@common-fe/common-fe';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

import CardActionCardHeader from './CardActionCardHeader';

interface CardLockUnlockActionCardProps {
  card: FiservCardInterface;
  loadingButton: boolean;
  onOpenLockUnlockCardModal: () => void;
}

const LOCKED_STATUSES = [FiservCardStatusEnum.FROZEN, FiservCardStatusEnum.PENDING_FROZEN];

const CardLockUnlockActionCard: React.FC<CardLockUnlockActionCardProps> = ({
  card,
  loadingButton,
  onOpenLockUnlockCardModal,
}) => {
  const isCardLocked = useMemo(() => LOCKED_STATUSES.includes(card.status), [card.status]);

  const buttonLabel = useMemo(() => (isCardLocked ? 'Unlock Card' : 'Lock Card'), [isCardLocked]);

  const title = buttonLabel;
  const description = (
    <>
      You can unlock this card
      <br />
      at any time.
    </>
  );

  return (
    <Box>
      <CardStatusActionWrap
        background="canvas"
        round="container1Round"
        border={{ color: 'border2', size: 'small' }}
      >
        <CardActionCardHeader
          icon={
            isCardLocked ? (
              <UnlockIcon size="xlarge" color="iconAccent" />
            ) : (
              <LockIcon size="xlarge" color="iconAccent" />
            )
          }
          title={title}
          description={description}
          descriptionLineHeight="20px"
        />
        <AppButton
          buttonType="primary"
          type="submit"
          width="100%"
          testId="card-lock-unlock-action-card_button"
          style={{ height: '40px', paddingInline: '12px' }}
          disabled={loadingButton}
          onClick={onOpenLockUnlockCardModal}
        >
          {loadingButton ? (
            <Box width="100%" align="center">
              <Preloader color="white" />
            </Box>
          ) : (
            buttonLabel
          )}
        </AppButton>
      </CardStatusActionWrap>
    </Box>
  );
};

export default CardLockUnlockActionCard;
